exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".DlCard{box-shadow:0 2px 12px 0 rgba(0,0,0,.1)}.DlCard .ant-card-body{padding:10px 20px;display:flex;height:120px}.DlCard .ant-card-body .left{height:100%;line-height:100px}.DlCard .ant-card-body .left img{width:70px;height:70px}.DlCard .ant-card-body .right{box-sizing:border-box;padding:15px 20px}.DlCard .ant-card-body .right .title{margin-bottom:30px;color:#333}.DlCard .ant-card-body .right .content{font-weight:400;font-size:24px;color:rgba(0,0,0,.85)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader/dist/cjs.js!./apps/pages/main/layout/css/DlCard.less
// module id = 1579
// module chunks = 1